import { lazy } from "react";

export const ExcelExportButton = lazy(() => import("./ExcelExportButton_"));
